import merge from 'lodash/merge';

export const EVENT_USER_PROPERTY = 'userProperty';
export const EVENT_USER_EVENT = 'userEvent';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface DataLayerPushEvent extends Record<string, any> {
  event: string;
}

export const dataLayerPush = (data: DataLayerPushEvent, action: 'push' | 'replace' = 'push') => {
  const isBrowser = typeof window !== 'undefined';
  if (!isBrowser) {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { dataLayer = [] }: { dataLayer: DataLayerPushEvent[] } = window as any;

  if (action === 'push') {
    dataLayer.push(data);
  } else {
    const eventIndex = dataLayer.findIndex(({ event }) => event === data.event);
    if (eventIndex >= 0) {
      dataLayer[eventIndex] = merge(dataLayer[eventIndex], data);
    }
  }
};

export const dataLayerPushAll = (events: DataLayerPushEvent[]) => {
  const isBrowser = typeof window !== 'undefined';
  if (!isBrowser) {
    return;
  }

  events.forEach((event) => dataLayerPush(event));
};
